import PropTypes from "prop-types";
import React, { useEffect } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom"
import ReactNotification from 'react-notifications-component';
import Routes from './routes';
import { setCurrentUser } from './redux/Actions/LoginActions';

function App({ checkUser }) {
  useEffect(() => {
    checkUser();
    AOS.refresh()
  }, [checkUser]);
  AOS.init()

  
  return (
    <>
      <ReactNotification />
      <Routes/>
    </>
  );
}

App.propTypes = {
  checkUser: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  checkUser: () => dispatch(setCurrentUser())
});

export default connect(null, mapDispatchToProps)(withRouter(App));
